module.exports = __webpack_public_path__ + "static/media/user_interview.e218a00b.png";